import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactSlider from "react-slider";
import "./range.css";

export const TransferFilter = ({ filterData, maxp, minp }) => {
  const [filterState, setfilterState] = useState({
    PriceSort: [],
    TransferType: [],
    PriceRange: [],
    Reset: false,
  });
  var filterTimer = "";
  const FilterHandler = (type, val) => {
    switch (type) {
      case "Reset":
        filterState["PriceRange"] = [];
        filterState["PriceSort"] = [];
        filterState["TransferType"] = [];
        filterState[type] = true;
        setfilterState(filterState);
        filterData(filterState);
        break;
      case "PriceSort":
        filterState["Reset"] = false;
        filterState[type] = [];
        filterState[type].push(val);
        setfilterState(filterState);
        filterData(filterState);
        break;
      case "PriceRange":
        clearTimeout(filterTimer);
        filterState["Reset"] = false;
        filterState["PriceRange"] = [];
        filterTimer = setTimeout(() => {
          val.map((p, i) => {
            filterState["PriceRange"].push(p);
          });
          setfilterState(filterState);
          filterData(filterState);
        }, 1000);
        break;
      default:
        filterState["Reset"] = false;
        const findss = filterState[type].find((f) => f === val);
        if (findss === undefined) {
          filterState[type] = [...filterState[type], val];
        } else {
          var ind = filterState[type].findIndex((f) => f === val);
          filterState[type].splice(ind, 1);
        }
        setfilterState(filterState);
        filterData(filterState);
        break;
    }
    // if (type === "Reset") {
    // }

    // if (type === "PriceSort") {
    // }

    // if (type === "PriceRange") {
    // }

    // if (type !== "PriceSort" && type !== "PriceRange" && type !== "Reset") {
    // }
  };

  return (
    <>
      <div aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Transfer
          </li>
        </ol>
      </div>
      <div className={`filter-wrap`}>
        <div className="filter-title">
          <h4>Sort & Filters</h4>
          <span onClick={() => FilterHandler("Reset", "0")}>Reset</span>
        </div>

        <div className="filter-inner-wrap">
          <div className="applied-filter-wrap"></div>
        </div>
      </div>

      <div className="filter-ctr">
        <h6 className="list-heading">Sort By</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceSort"].includes("MaxToMin")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceSort", "MaxToMin");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/high-to-low.svg" alt="" />
              </div>
              <div className="text">High to Low</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceSort"].includes("MinToMax")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceSort", "MinToMax");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/low-to-high.svg" alt="" />
              </div>
              <div className="text">Low to High</div>
            </div>
          </div>
        </div>
      </div>

      <div className="filter-ctr">
        <h6 className="list-heading">Transfer Type</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["TransferType"].includes("PvtTransfer")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("TransferType", "PvtTransfer");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/private.svg" alt="" />
              </div>
              <div className="text">Pvt Transfer</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["TransferType"].includes("Shared")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("TransferType", "Shared");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/share.svg" alt="Shared" />
              </div>
              <div className="text">Shared</div>
            </div>
          </div>
        </div>
      </div>

      <div className="filter-ctr price-range-main">
        <h6 className="list-heading">Price ($)</h6>
        {maxp > 0 ? (
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[minp, maxp]}
            min={parseInt(minp)}
            max={parseInt(maxp)}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            onChange={([min, max]) => {
              FilterHandler("PriceRange", [min, max]);
            }}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};
